var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testimonial text-center c-accent-bg-light p-5 m-t-4"},[_c('div',{staticClass:"testimonial-content"},[(_vm.heading)?_c('div',{staticClass:"header-label"},[_c('h4',{staticClass:"f-w-bold c-primary f-s-4"},[_vm._v(_vm._s(_vm.heading))])]):_vm._e(),_vm._v(" "),_c('testimonials',{attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }